import logger from '~util/logger';

const LOCAL_STORAGE_KEY = '__access_token__';

function getLocalToken() {
  return window.localStorage.getItem(LOCAL_STORAGE_KEY);
}

function persistLocalToken(token) {
  return window.localStorage.setItem(LOCAL_STORAGE_KEY, token);
}

function clearLocalToken() {
  return window.localStorage.removeItem(LOCAL_STORAGE_KEY);
}

function getTokenPayload(token) {
  try {
    let base64Payload = token.split('.')[1];
    base64Payload = base64Payload.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64Payload));
  } catch (err) {
    logger.error('Malformed token detected, logging out.');
    clearLocalToken();
    return null;
  }
}

export { getLocalToken, persistLocalToken, clearLocalToken, getTokenPayload };
